module.exports = __webpack_public_path__ + "static/smith-089d1bed031a0b96f68c08584f480edf.jpg";